import React from 'react';

export type IdentifierType = 'lotNumber' | 'traceCode' | 'batchLotNumber';

interface ClickableIdentifierProps {
  value: string;
  type: IdentifierType;
  onClick: (type: IdentifierType, value: string) => void;
}

export const ClickableIdentifier: React.FC<ClickableIdentifierProps> = ({ value, type, onClick }) => {
  return (
    <span
      onClick={(e) => {
        e.stopPropagation();
        onClick(type, value);
      }}
      style={{
        color: '#2196F3',
        cursor: 'pointer',
        textDecoration: 'underline'
      }}
      title={`View traceability for ${value}`}
    >
      {value}
    </span>
  );
};
